import type { LocationDescriptor } from 'history';
import type { HTMLAttributes, MouseEventHandler, ReactNode } from 'react';
import type { Settings } from 'react-slick';

export interface SectionCardItemSliderData {
  title?: ReactNode;
  subtitle?: ReactNode;
  showMoreText?: string;
  loading?: boolean;
  items?: ReactNode[];
  onShowMoreClick?: MouseEventHandler;
  showMoreLink?: LocationDescriptor;
  centered?: boolean;
  overrideSettings?: Settings;
  whiteArrows?: boolean;
  outlinedButtons?: boolean;
}

export interface SectionCardItemSliderProps
  extends SectionCardItemSliderData,
    Omit<HTMLAttributes<HTMLDivElement>, 'title'> {}
